var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"  border-top py-3 mt-1 "},[_c('div',{staticClass:"d-flex "},[_c('div',{staticClass:"mt-2 d-flex flex-wrap"},_vm._l((_vm.data.content.Image),function(item,index){return _c('div',{key:index},[_c('div',{staticClass:"panel-bg-file-img m-1",style:({
            backgroundImage: 'url(' + item.ImageUrl + ')'
          })})])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }